import React from 'react';
import Hero from './Hero';
// import FeatureModule from './FeatureModule';
import WhyChooseUs from './WhyChooseUs';
// import HowDoesItWork from './HowDoesItWork';
import Challenges from './Challenges';
import MeetIvy from './MeetIvy';
import CallToAction from './CallToAction';
// import HeroWithBackground from './HeroWithBackground';

function HomePage() {
  return (
    <>
      <Hero />
      <MeetIvy />
      {/* <HeroWithBackground /> */}
      {/* <FeatureModule /> */}
      <Challenges />
      {/* <HowDoesItWork /> */}
      <WhyChooseUs />

      <CallToAction />
    </>
  );
}

export default HomePage;
